var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1925 29.006C23.6004 29.006 29.6056 23.1258 29.6056 15.8723C29.6056 8.6187 23.6004 2.73853 16.1925 2.73853C8.78458 2.73853 2.7793 8.6187 2.7793 15.8723C2.7793 23.1258 8.78458 29.006 16.1925 29.006Z",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69562 15.8723H0.863281",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5218 15.8723H27.6895",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1934 4.6148V0.862305",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1934 30.8823V27.1298",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69562 15.8723H0.863281",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5218 15.8723H27.6895",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1934 4.6148V0.862305",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1934 30.8823V27.1298",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.385 13.3706C19.385 14.2 19.0486 14.9953 18.4496 15.5818C17.8507 16.1682 17.0384 16.4977 16.1914 16.4977",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52734 23.3773V21.8151C8.52734 21.1732 8.72908 20.5468 9.10517 20.0211C9.48126 19.4953 10.0135 19.0956 10.6296 18.8763L14.2758 17.8054V15.8581C13.8803 15.5691 13.5589 15.1939 13.3371 14.7621C13.1154 14.3303 12.9994 13.8539 12.9984 13.3706V11.6288C12.9849 10.8351 13.2715 10.0645 13.8031 9.46517C14.3347 8.86584 15.0738 8.48007 15.8783 8.382C16.322 8.33921 16.7699 8.38785 17.1933 8.52479C17.6166 8.66172 18.006 8.88392 18.3364 9.17709C18.6668 9.47025 18.9308 9.82789 19.1115 10.227C19.2922 10.6261 19.3856 11.0578 19.3856 11.4944V13.3706C19.3846 13.8539 19.2686 14.3303 19.0469 14.7621C18.8252 15.1939 18.5038 15.5691 18.1082 15.8581V17.8054L21.7685 18.897C22.3811 19.1184 22.9098 19.5182 23.2831 20.0428C23.6565 20.5674 23.8567 21.1914 23.8567 21.8308V23.3773",
    stroke: "#EEEBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1934 20.8756L16.1934 20.8756",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1934 23.3773L16.1934 23.3773",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.876247d16377fe6fcb5c000db43971dc.svg";
export { ForwardRef as ReactComponent };